import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {


  url = environment.serverAPI + "/api"; 
  
  constructor(private http: HttpClient) { }

  getAllMenu(): Observable<Object> {
		return this.http.get(`${this.url}/menu`);
	}

}
